module.exports = __webpack_public_path__ + "img/10.42d2e205.jpg";